import axios from './../../libs/api.request'

export function loginByPhone (account, password) {
  return axios.request({
    url: '/user/login/account',
    method: 'post',
    data: {
      phone: account,
      password: password
    }
  })
}

export function sendLoginSMSCode (phone) {
  return axios.request({
    url: '/user/sms/login?phone=' + phone,
    method: 'get'
  })
}

export function logout () {
  return axios.request({
    url: '/user/logout',
    method: 'get'
  })
}

export function sendResetPswSMSCode () {
  return axios.request({
    url: '/user/sms/set/password',
    method: 'get'
  })
}
export function updatePswBySMSCode (data) {
  return axios.request({
    url: '/user/password/set',
    method: 'post',
    data: data
  })
}
export function updatePsw (data) {
  return axios.request({
    url: '/user/password/update',
    method: 'post',
    data: data
  })
}
export function sendRegisterSMSCode (phone) {
  return axios.request({
    url: '/user/sms/register?phone=' + phone,
    method: 'get'
  })
}

//

export function loginBySMSCode (phone, smsCode) {
  return axios.request({
    url: '/user/login/sms?phone=' + phone + '&smsCode=' + smsCode,
    method: 'get'
  })
}

export function postRegisterInfo (phone, smsCode, password) {
  return axios.request({
    url: '/user/register/sms?phone=' + phone + '&smsCode=' + smsCode + '&password=' + password,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/components/Login/loginApi.js